interface TrackingConfigSection {
  currentPage: string;
  currentPageSection?: string;
  loginPromptType?: 'popup' | 'linkOut';
}

export type TrackingConfig = Record<string, TrackingConfigSection>;

const CURRENT_PAGES = {
  search: 'people search',
  searchResults: 'people search',
  profileDrawer: 'profile drawer',
  profile: 'public profile',
};

export const SEARCH_PAGE_TRACKING_EVENTS: TrackingConfig = {
  profileSearchDisplayed: {
    currentPage: CURRENT_PAGES.search,
  },
  // when user clicks on filters
  filterLoginModal: {
    currentPage: CURRENT_PAGES.search,
    currentPageSection: 'search filters',
    loginPromptType: 'popup',
  },
  // when user scrolls to the halfway point of the search results
  halfwayLoginModal: {
    currentPage: CURRENT_PAGES.search,
    currentPageSection: 'search results mid',
    loginPromptType: 'popup',
  },
  // when user clicks on the login banner after the search results
  loginBanner: {
    currentPage: CURRENT_PAGES.search,
    currentPageSection: 'search results',
  },
  // when user lands and clicks on the create profile banner (unauthenticated)
  createProfileBanner: {
    currentPage: CURRENT_PAGES.search,
    currentPageSection: 'search results',
  },
  // when user lands and clicks on the update your profile after the search results
  updateProfileBanner: {
    currentPage: CURRENT_PAGES.search,
    currentPageSection: 'search results',
  },
  // when user lands and clicks on the make your profile public after the search results
  makeProfilePublicBanner: {
    currentPage: CURRENT_PAGES.search,
    currentPageSection: 'search results',
  },
};

export const PROFILE_VIEW_TRACKING_EVENTS = {
  loginModal: {
    currentPage: CURRENT_PAGES.profile,
    currentPageSection: 'page content',
  },
};

export const PROFILE_DRAWER_TRACKING_EVENTS = {
  loginModal: {
    currentPage: CURRENT_PAGES.profileDrawer,
    currentPageSection: 'page content',
  },
};

export const SEARCH_RESULTS_TRACKING_EVENTS = {
  profileCard: {
    currentPage: CURRENT_PAGES.search,
    currentPageSection: 'profile summary',
    loginPromptType: 'linkOut' as const,
  },
  // bottom of search results list
  inListLoginModal: {
    currentPage: CURRENT_PAGES.search,
    currentPageSection: 'search results',
  },
};

export const LANDING_PAGE_TRACKING_EVENTS = {
  // when user lands and clicks on the create profile banner (unauthenticated)
  createProfileBanner: {
    currentPage: CURRENT_PAGES.search,
    currentPageSection: 'home landing page',
  },
  // when user lands and clicks on the update your profile after the search results
  updateProfileBanner: {
    currentPage: CURRENT_PAGES.search,
    currentPageSection: 'home landing page',
  },
  // when user lands and clicks on the make your profile public after the search results
  makeProfilePublicBanner: {
    currentPage: CURRENT_PAGES.search,
    currentPageSection: 'home landing page',
  },
};
